export namespace CONSTANT {
  /** 社員形態 */
  export enum EMP_STATUS {
    /** 正社員 */
    PERMANENT_EMP = 1,
    /** 契約社員 */
    CONSTRACT_WORKER = 2,
    /** 派遣社員 */
    TEMPORARY_EMP = 3,
    /** パート社員 */
    PART_TIME_STAFF = 4,
    /** 役員 */
    OFFICER = 5,
    /** アルバイト */
    ARBEIT = 6,
    /** 顧問 */
    ADVISER = 7,
    /** 管理ユーザー */
    USER_ADMIN = 9,
    /** 社外出向社員 */
    OUTSIDE_EMP = 11,
    /** ゲスト */
    GUEST_USER = 12,
    /** 総務担当 */
    GENERAL_AFFAIRS = 13,
    /** 給食センター */
    FOOD_CENTER = 14,
    /** いただきます端末 */
    ITADAKIMASU_TERM = 15,
    /** 食堂メニュー端末 */
    CAFE_MENU_TERM = 16,
    /** 厨房端末 */
    KITCHEN_TERM = 17,
  }

  export const APP_AUTH = {
    CREATE_PAYROLL_KBN: 'CreatePayrollKbn',
    HOJO_KBN: 'HojoKbn',
    AVAIL_GRP_CODE: 'avail_grp_code',
    HOJO_GRP_CODE: 'hojo_grp_code',
    MAIN_CAFE_CODE: 'main_cafe_code',
    GUEST_RESERVATION_AUTH: 'GuestReservationAuth',
    REDUCED_TAX_KBN: 'ReducedTaxKbn',
    COMMENT_IN_RSV: 'CommentInRsv',
    MULTIPLE_RSV: 'MultipleRsv',
    ITADAKIMASU_ATE_TYPE: 'ItadakimasuAteType',
    GUEST_PAYMENT_TYPE: 'GuestPaymentType',
  };

  /** カードスキャン系画面を使用できる社員を指定 */
  export const ALLOW_CARD_SCAN_EMP_STATUS = [13, 14, 15, 16, 17];

  export const UG_OPTION = {
    RESERVATION: 'reservation',
    COMMENT_IN_RSV: 'commentInRsv',
    ITADAKIMASU: 'itadakimasu',
    NO_RSV_ITADAKIMASU: 'no_rsv_itadakimasu',
    CAFETERIA: 'cafeteria',
    SELF_REGI: 'self_regi',
    SUB_MENU: 'sub_menu',
    GA_MODIFY_RSV: 'ga_modify_rsv',
  };

  export const SMILE9_USER_SETTINGS = {
    ALLOW_SEARCH_EMP_CODE: 'allow_search_emp_code',
    SCAN_TYPE: 'scan_type',
    ALL_CO_COST_AT_NOT_HOJO_CAFE: 'all_co_cost_at_not_hojo_cafe',
    ALLOW_SELECT_GUEST_CAFE: 'allow_select_guest_cafe',
    AVAILABLE_TIME_IN_CARD_RSV: 'available_time_in_card_rsv',
    ADD_PREFIX_TO_SMILE9ID: 'add_prefix_to_smile9id',
    ALLOW_GA_MODIFY_RSV: 'allow_ga_modify_rsv',
    ALLOW_GA_MODIFY_ATE: 'allow_ga_modify_ate',
    DISPLAY_GA_ITADAKIMASU_SETTINGS: 'display_ga_itadakimasu_settings',
    ALLOW_FAXMAIL_SETTINGS: 'allow_faxmail_settings',
    ALLOW_RSV_CALENDAR: 'allow_rsv_calendar',
    ALLOW_DASHBOARD: 'allow_dashboard',
    ALLOW_FSC_DASHBOARD_DEPT: 'allow_fsc_dashboard_dept',
    ALLOW_NUTRITION_BALANCE: 'allow_nutrition_balance',
  };

  export const SERVICE_ROLE = {
    USER: 'User',
    FSC: 'FSC',
    SYSTEM: 'System',
  };

  export const SCAN_TYPE = {
    IC_CARD: 'ic_card',
    MAGNETIC_CARD: 'magnetic_card',
    QR_CODE: 'qr_code',
    MIX: 'mix',
  };

  export const CAFE_FUNCTION = {
    RESERVATION: 'reservation',
    ITADAKIMASU: 'itadakimasu',
    NO_RSV_ITADAKIMASU: 'no_rsv_itadakimasu',
    CAFETERIA: 'cafeteria',
    SELF_REGI: 'self_regi',
  };

  export const CREATE_PAYROLL_KBN = {
    NO_CREATE: 'NoCreate',
    CREATE: 'Create',
  };

  export const HOJO_KBN = {
    ELIGIBLE: 'Eligible',
    NOT_ELIGIBLE: 'NotEligible',
  };

  export const GUEST_RESERVATION_AUTH = {
    NO_AUTHORITY: 'NoAuthority',
    AUTHORIZED: 'Authorized',
  }

  export const GUEST_PAYMENT_TYPE = {
    UN_SPECIFIED: 'UnSpecified',
    PAY_BY_CASH: 'PayByCash',
  };

  export const MULTIPLE_RSV = {
    ENABLED: 'Enabled',
    DISABLED: 'Disabled',
  };

  export const ITADAKIMASU_ATE_TYPE = {
    SET_QUANTITY: 'SetQuantity',
    ATE_AT_ONCE: 'AteAtOnce',
  };

  export const API_ERROR_CODE = {
    DUPLICATED_PERIOD: 'DuplicatedPeriod',
    OVER_REGISTERATION_LIMIT: 'OverRegistrationLimit',
    NOT_FOUNDED_USERNAME: 'NotFoundedUsername',
    NOT_FOUNDED_FELICA: 'NotFoundedFelica',
    CONFLICT_WITH_OTHER_TERMINAL: 'ConflictWithOtherTerminal',
    CONFLICT_DUE_TO_ANGULAR_HAS_OLD_DATA: 'ConflictDueToAngularHasOldData',
    BAD_DATA_FOUND_IN_CSV: 'BadDataFoundInCsv',
    LACKING_VALUE_CSV: 'LackingValueCsv',
    OVER_LIMIT_CSV_ROW: 'OverLimitCsvRow',
    OVER_LIMIT: 'OverLimit',
    RSV_CONSISTENCY: 'RsvConsistency',
    SUB_RSV_CONSISTENCY: 'SubRsvConsistency',
  };

  export const LOG_S3_PLACE = 'AmazonS3/logs.astro-rb.com';

  export const RSV_STATUS = {
    /** 通常予約 */
    RSV: 0,
    /** 締後予約 */
    RSV_OVER_R_DEADLINE: 2,
    /** 通常実績 */
    ATE: 1,
    /** 締後実績 */
    ATE_OVER_R_DEADLINE: 3,
    /** 通常キャンセル */
    CANCEL: 9,
    /** 締後キャンセル */
    CANCEL_OVER_C_DEADLINE: 10,
  };

  /** メールタイプ */
  export const MAIL_TYPE = {
    /** 自由記入 */
    FREE: 'free',
    /** アカウント通知書 */
    NOTIFY_ACCOUNT: 'notify_account',
  };

  export const ITADAKIMASU_SETTINGS = {
    AUTO_CARD_SIGNIN: 'auto_card_signin',
    AUTO_CARD_SIGNOUT: 'auto_card_signout',
    BIG_FONT_MODE: 'big_font_mode',
    DISPLAY_MILLISEC_ON_SCAN_RESULT: 'display_millisec_on_scan_result',
    ITADAKIMASU_TARGET: 'itadakimasu_target',
    NO_RSV_SCAN_CARD_TARGET: 'no_rsv_scan_card_target',
    CAFETERIA_TARGET: 'cafeteria_target',
    SELF_REGI_TARGET: 'self_regi_target',
    HIDE_HEADER: 'hide_header',
  };

  export const MENU_PATTERN_ATTRIBUTE = {
    INPUT_RSVD_QTY_LIMIT: 'input_rsvd_qty_limit',
    RSV_CALENDAR_LABEL: 'rsv_calendar_label',
  };

  export const FAX_MAIL_TASK_STATUS = {
    READY: 'ready',
    REQUEST_SENDING: 'request_sending',
    OBSERVE_STATUS: 'observe_status',
    FAILED: 'failed',
    TOO_LONG_EXECUTION_TIME: 'too_long_execution_time',
    EXCEPTION: 'exception',
    COMPLETED: 'completed',
  };

  export const FAX_MAIL_SENDING_FREQUENCY = {
    REGULARLY: 'regularly',
    ONE_SHOT: 'one_shot',
    BIGINNING_OF_THE_MONTH: 'beginning_of_the_month',
  };

  export const FAX_MAIL_SENDING_TYPE = {
    FAX: 'fax',
    MAIL: 'mail',
  };

  export const FAX_MAIL_SENDING_CONTENTS = {
    RSV_STATUS: 'rsv_status',
    TEMP_AGENCY_DETAILS_XLSX: 'temp_agency_details_xlsx',
  };

  export const RSV_CALENDAR_INPUT_TYPE = {
    SINGLE_MENU: 'SingleMenu',
    MULTIPLE_MENU: 'MultipleMenu',
  }

  export const REDUCED_TAX_KBN = {
    ELIGIBLE: 'Eligible',
    NOT_ELIGIBLE: 'NotEligible',
  }

  export const COMMENT_IN_RSV = {
    AUTHORIZED: 'Authorized',
    NO_AUTHORITY: 'NoAuthority',
  }
}

